import React from "react"
import { useAppContext } from "../../../providers/AppProvider"

const Wrapper = ({ children }) => {
  const { profile } = useAppContext()

  return (
    <div className={`content-wrap${profile.embedded ? " embedded" : ""}`}>
      {children}
    </div>
  )
}

export default Wrapper
